(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[313],{

/***/ 5288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ InformationSection; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
// EXTERNAL MODULE: ./components/molecules/OptimizedImage/index.tsx + 2 modules
var OptimizedImage = __webpack_require__(7841);
;// CONCATENATED MODULE: ./components/molecules/InformationSection/styled.ts


var styled_InformationSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styled__InformationSection",
  componentId: "sc-1pm8nc-0"
})(function (_ref) {
  var topMargin = _ref.topMargin,
      highlightHeader = _ref.highlightHeader;
  return [{
    "display": "grid",
    "width": "100%",
    "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
    "@media (min-width: 1024px)": {
      "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
      "gridTemplateRows": "minmax(calc(100vh - 72px), min-content)",
      "scrollSnapAlign": "start"
    }
  }, topMargin && !highlightHeader && {
    "marginTop": "6rem"
  }, highlightHeader && {
    "marginTop": "2rem"
  }, highlightHeader && topMargin && {
    "@media (min-width: 1024px)": {
      "marginTop": "6rem"
    }
  }];
});
var InformationImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__InformationImageWrapper",
  componentId: "sc-1pm8nc-1"
})(["", " ", " > *{grid-column:1 / span 1;grid-row:1 / span 1;}"], {
  "height": "28rem",
  "width": "100%",
  "@media (min-width: 768px)": {
    "height": "40rem"
  },
  "@media (min-width: 1024px)": {
    "height": "100%",
    "maxHeight": "calc(100vh - 72px)"
  },
  "@media (max-height: 800px)": {
    "height": "25rem"
  }
}, {
  "position": "relative",
  "display": "grid",
  "@media (min-width: 1024px)": {
    "position": "sticky",
    "height": "calc(100vh - 72px)",
    "top": "72px"
  }
});
var InformationImage = (0,styled_components_browser_esm/* default */.ZP)(OptimizedImage/* OptimizedImage */.d).withConfig({
  displayName: "styled__InformationImage",
  componentId: "sc-1pm8nc-2"
})(["", ""], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 196 37 / var(--tw-bg-opacity))",
  ".dark &": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(84 49 36 / var(--tw-bg-opacity))"
  }
});
var LinkImageAttribution = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "styled__LinkImageAttribution",
  componentId: "sc-1pm8nc-3"
})(["", " > div{", "}"], {
  "zIndex": "10",
  "placeSelf": "end"
}, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(17 17 17 / var(--tw-bg-opacity))",
  "paddingLeft": "0.25rem",
  "paddingRight": "0.25rem",
  "fontSize": "0.75rem",
  "lineHeight": "1rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "0.4"
});
var ImageAttribution = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__ImageAttribution",
  componentId: "sc-1pm8nc-4"
})(["", ""], {
  "zIndex": "10",
  "placeSelf": "end",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(17 17 17 / var(--tw-bg-opacity))",
  "paddingLeft": "0.25rem",
  "paddingRight": "0.25rem",
  "fontSize": "0.75rem",
  "lineHeight": "1rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "0.4"
});
var HighlightedHeader = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "styled__HighlightedHeader",
  componentId: "sc-1pm8nc-5"
})(["", ""], {
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingBottom": "2rem",
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});
var InformationContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__InformationContent",
  componentId: "sc-1pm8nc-6"
})(["", " ", " > p:not(:first-of-type){", "}> ul{", "}"], {
  "alignSelf": "center",
  "padding": "1.5rem",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  "@media (min-width: 768px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  },
  "@media (min-width: 1024px)": {
    "paddingTop": "2rem",
    "paddingBottom": "2rem"
  },
  "@media (min-width: 1280px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  }
}, {
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem"
}, {
  "paddingTop": "1.5rem"
}, {
  "listStylePosition": "outside",
  "listStyleType": "disc",
  "paddingTop": "1.5rem",
  "paddingInlineStart": "2rem"
});
var InformationContentHeader = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "styled__InformationContentHeader",
  componentId: "sc-1pm8nc-7"
})(function (_ref2) {
  var highlightHeader = _ref2.highlightHeader;
  return [{
    "paddingBottom": "1.5rem",
    "@media (min-width: 1536px)": {
      "paddingBottom": "2rem"
    }
  }, {
    "fontSize": "1.875rem",
    "lineHeight": "2.25rem",
    "@media (min-width: 1536px)": {
      "fontSize": "2.25rem",
      "lineHeight": "2.5rem"
    }
  }, highlightHeader && {
    "display": "none",
    "@media (min-width: 1024px)": {
      "display": "block"
    }
  }];
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/molecules/InformationSection/index.tsx




var InformationSection = function InformationSection(_ref) {
  var imageSrc = _ref.imageSrc,
      imageAttribution = _ref.imageAttribution,
      header = _ref.header,
      _ref$topMargin = _ref.topMargin,
      topMargin = _ref$topMargin === void 0 ? true : _ref$topMargin,
      children = _ref.children,
      _ref$highlightHeader = _ref.highlightHeader,
      highlightHeader = _ref$highlightHeader === void 0 ? false : _ref$highlightHeader,
      _ref$objectFit = _ref.objectFit,
      objectFit = _ref$objectFit === void 0 ? 'cover' : _ref$objectFit,
      objectPosition = _ref.objectPosition,
      _ref$priority = _ref.priority,
      priority = _ref$priority === void 0 ? false : _ref$priority;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styled_InformationSection, {
    topMargin: topMargin,
    highlightHeader: highlightHeader,
    children: [highlightHeader && header != null && /*#__PURE__*/(0,jsx_runtime.jsx)(HighlightedHeader, {
      children: header
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InformationImageWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InformationImage, {
        alt: '',
        src: imageSrc,
        priority: priority,
        objectFit: objectFit,
        objectPosition: objectPosition,
        layout: 'fill'
      }), imageAttribution != null && (imageAttribution.link != null ? /*#__PURE__*/(0,jsx_runtime.jsx)(LinkImageAttribution, {
        href: imageAttribution.link,
        target: '_blank',
        rel: 'noreferrer noopener',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: imageAttribution.content
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ImageAttribution, {
        children: imageAttribution.content
      }))]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InformationContent, {
      children: [header != null && /*#__PURE__*/(0,jsx_runtime.jsx)(InformationContentHeader, {
        highlightHeader: highlightHeader,
        children: header
      }), children]
    })]
  });
};

/***/ }),

/***/ 9998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ components; }
});

// EXTERNAL MODULE: ./components/molecules/Mdx/styled.tsx
var styled = __webpack_require__(3649);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
;// CONCATENATED MODULE: ./components/molecules/ContentBanner/styled.tsx

var BannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__BannerWrapper",
  componentId: "sc-1pasw04-0"
})(["", ""], {
  "display": "grid",
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
  "gridTemplateRows": "repeat(1, minmax(0, 1fr))"
});
var BannerTextContent = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
  displayName: "styled__BannerTextContent",
  componentId: "sc-1pasw04-1"
})(["", " ", " ", " ", " a{", "}"], {
  "alignSelf": "center",
  "gridColumn": "1 / span 1",
  "gridRow": "1 / span 1"
}, {
  "marginLeft": "auto",
  "marginRight": "auto",
  "width": "100%",
  "maxWidth": "56rem",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "@media (min-width: 1280px)": {
    "maxWidth": "48rem"
  },
  "@media (min-width: 1536px)": {
    "maxWidth": "56rem"
  }
}, {
  "marginLeft": "auto",
  "marginRight": "auto",
  "width": "100%",
  "fontSize": "1.5rem",
  "lineHeight": "1.5",
  "@media (min-width: 768px)": {
    "fontSize": "2rem"
  },
  "@media (min-width: 1280px)": {
    "fontSize": "2.25rem"
  },
  "@media (min-width: 1536px)": {
    "lineHeight": "1.625",
    "fontSize": "2.65rem"
  }
}, {
  "paddingTop": "1.5rem",
  "paddingBottom": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "fontFamily": "Lora"
}, {
  "--tw-text-opacity": "1 !important",
  "color": "rgb(255 196 37 / var(--tw-text-opacity)) !important",
  "textDecorationLine": "underline"
});
var BannerBackground = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "styled__BannerBackground",
  componentId: "sc-1pasw04-2"
})(["", ""], {
  "height": "100%",
  "width": "100%",
  "gridColumn": "1 / span 1",
  "gridRow": "1 / span 1"
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/molecules/ContentBanner/index.tsx




var ContentBanner = function ContentBanner(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BannerWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BannerBackground, {
      alt: '',
      src: '/images/roughstock/banner-bg.png'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BannerTextContent, {
      children: children
    })]
  });
};
;// CONCATENATED MODULE: ./components/molecules/PdfViewer/styled.tsx

var FormattedEmbed = styled_components_browser_esm/* default.embed.withConfig */.ZP.embed.withConfig({
  displayName: "styled__FormattedEmbed",
  componentId: "sc-1tzrh5e-0"
})(["", ""], {
  "display": "none",
  "maxHeight": "100vh",
  "@media (min-width: 1024px)": {
    "display": "block",
    "height": "40rem"
  },
  "@media (min-width: 1280px)": {
    "height": "50rem"
  }
});
;// CONCATENATED MODULE: ./components/molecules/PdfViewer/index.tsx



var PdfViewer = function PdfViewer(_ref) {
  var path = _ref.path;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedEmbed, {
    src: path,
    type: 'application/pdf'
  });
};
;// CONCATENATED MODULE: ./components/molecules/Mdx/components.tsx






var hr = function hr() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: 'hr',
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* HorizontalBreak */.f, {})
  });
};

var components = {
  ContentBanner: ContentBanner,
  hr: hr,
  PdfViewer: PdfViewer
};

/***/ }),

/***/ 5841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ Mdx; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next-mdx-remote/index.js + 3 modules
var next_mdx_remote = __webpack_require__(2154);
// EXTERNAL MODULE: ./components/molecules/Mdx/components.tsx + 4 modules
var components = __webpack_require__(9998);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../packages/design-system/mdx/wrapper/src/styles.ts
var styles = __webpack_require__(2351);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../packages/design-system/mdx/wrapper/src/index.tsx


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var MdxWrapper = function MdxWrapper(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* Wrapper */.i, _objectSpread(_objectSpread({}, rest), {}, {
    children: children
  }));
};

/* harmony default export */ var src = (MdxWrapper);
;// CONCATENATED MODULE: ../../packages/design-system/mdx/wrapper/index.ts

/* harmony default export */ var wrapper = (src);
// EXTERNAL MODULE: ./components/molecules/Mdx/styled.tsx
var styled = __webpack_require__(3649);
;// CONCATENATED MODULE: ./components/molecules/Mdx/index.tsx


function Mdx_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Mdx_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Mdx_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Mdx_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Mdx = function Mdx(_ref) {
  var mdx = _ref.mdx;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(wrapper, {
    styles: styled/* WWW_MDX_OVERRIDE_STYLES */.r,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_mdx_remote/* MDXRemote */.R, Mdx_objectSpread(Mdx_objectSpread({}, mdx), {}, {
      components: components/* components */.w
    }))
  });
};

/***/ }),

/***/ 3649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ HorizontalBreak; },
/* harmony export */   "r": function() { return /* binding */ WWW_MDX_OVERRIDE_STYLES; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1895);
/* harmony import */ var _ColoredBorderWrapper_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3419);



var HorizontalBreak = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
  displayName: "styled__HorizontalBreak",
  componentId: "sc-fikjku-0"
})(["", " ", ""], _ColoredBorderWrapper_styled__WEBPACK_IMPORTED_MODULE_0__/* .gradientBackground */ .P, {
  "height": "0.125rem",
  "borderWidth": "0px"
});
var WWW_MDX_OVERRIDE_STYLES = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["a{", "}"], {
  "--tw-text-opacity": "1",
  "color": "rgb(0 151 137 / var(--tw-text-opacity))",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(65 205 127 / var(--tw-text-opacity))"
  }
});

/***/ }),

/***/ 7841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ OptimizedImage; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(8421);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../packages/design-system/next-image/src/index.tsx


var _excluded = ["appEnv"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/*
    Based on Example laid out by Cloudflare:
    https://developers.cloudflare.com/images/image-resizing/integration-with-frameworks/
*/



var normalizeSrc = function normalizeSrc(src) {
  return src.startsWith('/') ? src.slice(1) : src;
};

var cloudflareLoader = function cloudflareLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  var params = ['fit=scale-down', "width=".concat(width)];

  if (quality) {
    params.push("quality=".concat(quality));
  }

  var paramsString = params.join(',');
  return "/cdn-cgi/image/".concat(paramsString, "/").concat(normalizeSrc(src));
};

var localLoader = function localLoader(_ref2) {
  var src = _ref2.src;
  return "/".concat(normalizeSrc(src));
};

var cloudflareEnvs = ['stage', 'production', 'sandbox2', 'eks-stage'];
var localEnvs = ['local', 'test'];
var NextOptimizedImage = function NextOptimizedImage(_ref3) {
  var appEnv = _ref3.appEnv,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded);

  var imageLoader = (0,react.useMemo)(function () {
    return cloudflareEnvs.includes(appEnv) ? cloudflareLoader : localEnvs.includes(appEnv) ? localLoader : undefined;
  }, [appEnv]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), _objectSpread({
    loader: imageLoader
  }, rest));
};
;// CONCATENATED MODULE: ../../packages/design-system/next-image/index.ts

/* harmony default export */ var next_image = (NextOptimizedImage);
// EXTERNAL MODULE: ./config/env.ts
var env = __webpack_require__(8199);
;// CONCATENATED MODULE: ./components/molecules/OptimizedImage/index.tsx


function OptimizedImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OptimizedImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OptimizedImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OptimizedImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var OptimizedImage = function OptimizedImage(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(next_image, OptimizedImage_objectSpread({
    appEnv: env/* APP_ENV */.Wi
  }, props));
};

/***/ }),

/***/ 6751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ Shell; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
;// CONCATENATED MODULE: ./components/molecules/NavBar/styled.ts

var styled_NavBar = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "styled__NavBar",
  componentId: "sc-1pq2k3n-0"
})(["", " > div{", "}a{", "}"], {
  "position": "sticky",
  "zIndex": "10",
  "display": "grid",
  "width": "100%",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "0.95",
  "gridTemplateRows": "72px",
  "top": "0",
  "height": "72px",
  "@media (min-width: 1024px)": {
    "scrollSnapAlign": "start"
  }
}, {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "@media (min-width: 1024px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  }
}, {
  "textDecorationLine": "none"
});
var Logo = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "styled__Logo",
  componentId: "sc-1pq2k3n-1"
})(["", " svg{", " path{fill:url('#custodia-mark_svg__a');}}span{", "}"], {
  "display": "flex",
  "alignItems": "center",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
}, {
  "height": "2.5rem"
}, {
  "marginLeft": "0.5rem",
  "fontWeight": "700"
});
var NavItemTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__NavItemTitle",
  componentId: "sc-1pq2k3n-2"
})(function (_ref) {
  var isSelected = _ref.isSelected;
  return [{
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    ":hover": {
      "opacity": "0.7"
    }
  }, isSelected && {
    "fontWeight": "700"
  }];
});
var DesktopRightContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__DesktopRightContent",
  componentId: "sc-1pq2k3n-3"
})(["", ""], {
  "display": "flex"
});
var DesktopNavItems = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styled__DesktopNavItems",
  componentId: "sc-1pq2k3n-4"
})(["", ""], {
  "display": "none",
  "listStyleType": "none",
  "gridTemplateColumns": "repeat(3, auto)",
  "alignItems": "center",
  "gap": "3rem",
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "@media (min-width: 1024px)": {
    "display": "grid"
  }
});
var MobileNavItems = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styled__MobileNavItems",
  componentId: "sc-1pq2k3n-5"
})(function (_ref2) {
  var menuOpen = _ref2.menuOpen;
  return [{
    "display": "none",
    "listStyleType": "none",
    "alignItems": "center",
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "paddingTop": "1rem",
    "paddingBottom": "1rem",
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "marginTop": "-0.1rem"
  }, {
    "position": "sticky",
    "left": "0px",
    "zIndex": "10",
    "height": "calc(100vh - 72px + 0.1rem)",
    "width": "100%",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
    "top": "72px"
  }, menuOpen && {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "gap": "1.75rem",
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "@media (min-width: 1024px)": {
      "display": "none"
    }
  }];
});
var MobileMenuSpacer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MobileMenuSpacer",
  componentId: "sc-1pq2k3n-6"
})(["", ""], {
  "width": "100%",
  "flexGrow": "1"
});
var MobileSubscribeButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MobileSubscribeButtonWrapper",
  componentId: "sc-1pq2k3n-7"
})(["", " button{", "}"], {
  "width": "100%",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingBottom": "1rem"
}, {
  "display": "block",
  "width": "100%"
});
var DarkModeButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__DarkModeButton",
  componentId: "sc-1pq2k3n-8"
})(["", ""], {
  "marginLeft": "1.5rem",
  "display": "none",
  "@media (min-width: 1024px)": {
    "display": "block"
  }
});
var MenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__MenuButton",
  componentId: "sc-1pq2k3n-9"
})(["", ""], {
  "padding": "0.25rem",
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});
// EXTERNAL MODULE: ../../node_modules/react-icons/vsc/index.mjs
var vsc = __webpack_require__(8097);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./assets/custodia-mark.svg
var custodia_mark = __webpack_require__(5426);
// EXTERNAL MODULE: ./components/molecules/ColoredBorderWrapper/styled.ts
var styled = __webpack_require__(3419);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/molecules/ColoredBorderWrapper/index.tsx




var ColoredBorderWrapper = function ColoredBorderWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* Border */.O, {})]
  });
};
;// CONCATENATED MODULE: ./components/molecules/NavBar/index.tsx









var ROUTES = [{
  title: 'Avit',
  href: '/avit'
}, {
  title: 'Press',
  href: '/press'
}, {
  title: 'About',
  href: '/about'
}];
var NavBar = function NavBar() {
  var _useState = (0,react.useState)(false),
      menuOpen = _useState[0],
      setMenuOpen = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styled_NavBar, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: '/',
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Logo, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(custodia_mark/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Custodia"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopRightContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MenuButton, {
          onClick: function onClick() {
            return setMenuOpen(!menuOpen);
          },
          "aria-expanded": !!menuOpen,
          "aria-label": "Menu",
          "aria-controls": "nav-menu",
          children: menuOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(vsc/* VscClose */.ven, {
            size: 25
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(vsc/* VscThreeBars */.QEj, {
            size: 25
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DesktopNavItems, {
          children: ROUTES.map(function (r) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem, {
              href: r.href,
              title: r.title
            }, r.href);
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileNavItems, {
      menuOpen: menuOpen,
      id: 'nav-menu',
      children: [ROUTES.map(function (r) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem, {
          href: r.href,
          title: r.title
        }, r.href);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MobileMenuSpacer, {})]
    })]
  });
};

var NavItem = function NavItem(_ref) {
  var href = _ref.href,
      title = _ref.title,
      external = _ref.external;
  var router = (0,next_router.useRouter)();
  var isCurrentRoute = !external && (router.route === href || // highlight "Avit" on /avit and any nested page (e.g. the redemption page)
  href === '/avit' && router.route.startsWith('/avit/'));

  var content = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    children: isCurrentRoute ? /*#__PURE__*/(0,jsx_runtime.jsx)(ColoredBorderWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavItemTitle, {
        isSelected: isCurrentRoute,
        children: title
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(NavItemTitle, {
      isSelected: isCurrentRoute,
      children: title
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: external ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: href,
      children: content
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: href,
      children: content
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/design-system/footer/index.ts + 3 modules
var footer = __webpack_require__(2890);
// EXTERNAL MODULE: ./components/molecules/Shell/styled.ts
var Shell_styled = __webpack_require__(564);
// EXTERNAL MODULE: ./hooks/useIsBrowser.ts
var useIsBrowser = __webpack_require__(9612);
// EXTERNAL MODULE: ../../packages/design-system/cookie-banner/index.tsx + 4 modules
var cookie_banner = __webpack_require__(86);
;// CONCATENATED MODULE: ./components/molecules/Shell/index.tsx










var Shell = function Shell(_ref) {
  var _ref$enableSnapPoints = _ref.enableSnapPoints,
      enableSnapPoints = _ref$enableSnapPoints === void 0 ? false : _ref$enableSnapPoints,
      children = _ref.children;
  var isBrowser = (0,useIsBrowser/* useIsBrowser */.E)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Shell_styled/* ShellWrapper */.r, {
      className: classnames_default()({
        dark: true
      }),
      enableSnapPoints: enableSnapPoints,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Shell_styled/* ContentWrapper */.v, {
        children: children
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(footer/* default */.ZP, {}), isBrowser && /*#__PURE__*/(0,jsx_runtime.jsx)(cookie_banner/* default */.Z, {})]
    })
  });
};

/***/ }),

/***/ 875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ press; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/molecules/Seo/index.tsx
var Seo = __webpack_require__(1424);
// EXTERNAL MODULE: ./components/molecules/Shell/index.tsx + 3 modules
var Shell = __webpack_require__(6751);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
// EXTERNAL MODULE: ./components/molecules/OptimizedImage/index.tsx + 2 modules
var OptimizedImage = __webpack_require__(7841);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/screens/press/styled.ts



var styled_Screen = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Screen",
  componentId: "sc-nu9xd8-0"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column"
});
var PressReleaseDate = styled_components_browser_esm/* default.time.withConfig */.ZP.time.withConfig({
  displayName: "styled__PressReleaseDate",
  componentId: "sc-nu9xd8-1"
})(["", ""], {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "letterSpacing": "0.2rem",
  "--tw-text-opacity": "1",
  "color": "rgb(209 213 219 / var(--tw-text-opacity))"
});
var PressTopHeader = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "styled__PressTopHeader",
  componentId: "sc-nu9xd8-2"
})(["", ""], {
  "paddingTop": "0.5rem",
  "paddingBottom": "2.5rem",
  "fontSize": "3rem",
  "lineHeight": "1"
});
var ReadMoreNextLink = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
  displayName: "styled__ReadMoreNextLink",
  componentId: "sc-nu9xd8-3"
})(["", ""], {
  "textDecorationLine": "none"
});
var ReadMoreLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__ReadMoreLink",
  componentId: "sc-nu9xd8-4"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem",
  "paddingTop": "1.5rem",
  "textTransform": "uppercase",
  "--tw-text-opacity": "1",
  "color": "rgb(0 151 137 / var(--tw-text-opacity))",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(65 205 127 / var(--tw-text-opacity))"
  }
});
var PressReleasesSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styled__PressReleasesSection",
  componentId: "sc-nu9xd8-5"
})(["", ""], {
  "marginTop": "6rem",
  "display": "grid",
  "width": "100%",
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
  "@media (min-width: 1024px)": {
    "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
    "gridTemplateRows": "minmax(100vh, min-content)"
  }
});
var PressReleasesList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__PressReleasesList",
  componentId: "sc-nu9xd8-6"
})(["", " > h3{", "}> ul{", " > li{", " > a{", "}}}"], {
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingBottom": "4rem",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  "@media (min-width: 1024px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  },
  "@media (min-width: 1280px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  }
}, {
  "paddingTop": "2rem",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "@media (min-width: 1024px)": {
    "paddingTop": "0px"
  }
}, {
  "listStyleType": "none",
  "paddingTop": "1.5rem"
}, {
  "paddingTop": "2rem",
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "letterSpacing": "0.2rem"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "textDecorationLine": "none",
  ":hover": {
    "--tw-text-opacity": "1",
    "color": "rgb(0 151 137 / var(--tw-text-opacity))"
  },
  ".dark &:hover": {
    "--tw-text-opacity": "1",
    "color": "rgb(65 205 127 / var(--tw-text-opacity))"
  }
});
var PressInquiresNote = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__PressInquiresNote",
  componentId: "sc-nu9xd8-7"
})(["", " > a{", "}"], {
  "paddingTop": "1.5rem"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(0 151 137 / var(--tw-text-opacity))",
  "textDecorationLine": "none",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(65 205 127 / var(--tw-text-opacity))"
  }
});
var PressReleaseSectionImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__PressReleaseSectionImageWrapper",
  componentId: "sc-nu9xd8-8"
})(["", " ", " ", ""], {
  "gridColumn": "1 / span 1",
  "gridRow": "1 / span 1",
  "@media (min-width: 1024px)": {
    "gridColumn": "2 / span 1"
  }
}, {
  "position": "relative",
  "height": "40rem",
  "width": "100%",
  "@media (min-width: 1024px)": {
    "height": "100%"
  }
}, {
  "@media (min-width: 1024px)": {
    "position": "sticky",
    "height": "calc(100vh - 72px)",
    "top": "72px"
  }
});
var PressReleaseSectionImage = (0,styled_components_browser_esm/* default */.ZP)(OptimizedImage/* OptimizedImage */.d).withConfig({
  displayName: "styled__PressReleaseSectionImage",
  componentId: "sc-nu9xd8-9"
})(["", ""], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 196 37 / var(--tw-bg-opacity))",
  ".dark &": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(84 49 36 / var(--tw-bg-opacity))"
  }
});
// EXTERNAL MODULE: ./components/molecules/InformationSection/index.tsx + 1 modules
var InformationSection = __webpack_require__(5288);
// EXTERNAL MODULE: ../../node_modules/react-icons/bs/index.mjs
var bs = __webpack_require__(7285);
// EXTERNAL MODULE: ./components/molecules/Mdx/index.tsx + 2 modules
var Mdx = __webpack_require__(5841);
// EXTERNAL MODULE: ./utils/index.ts
var utils = __webpack_require__(8254);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/screens/press/index.tsx










var Screen = function Screen(_ref) {
  var featurePressRelease = _ref.featurePressRelease,
      featurePressReleaseMdx = _ref.featurePressReleaseMdx,
      pressReleases = _ref.pressReleases;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Shell/* Shell */.N, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(styled_Screen, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InformationSection/* InformationSection */.K, {
        imageSrc: '/images/press/barn.webp',
        priority: true,
        topMargin: false,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PressReleaseDate, {
          children: (0,utils/* parseAndFormatDateForPresRelease */.R)(featurePressRelease.date)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PressTopHeader, {
          children: featurePressRelease.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Mdx/* Mdx */.i, {
          mdx: featurePressReleaseMdx
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReadMoreNextLink, {
          href: "/press/".concat(featurePressRelease.slug),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ReadMoreLink, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "Read More"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(bs/* BsBoxArrowUpRight */.y_S, {})]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PressReleasesSection, {
        id: 'press-releases',
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PressReleasesList, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            children: "Press Releases"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            children: pressReleases.map(function (pr) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/press/".concat(pr.slug),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: pr.title
                  })
                })
              }, pr.slug);
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PressInquiresNote, {
            children: ["For press inquiries, please contact", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: 'mailto: press@custodiabank.com',
              children: "press@custodiabank.com"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PressReleaseSectionImageWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PressReleaseSectionImage, {
            alt: '',
            src: '/images/press/horses.webp',
            objectFit: 'cover',
            objectPosition: '82% 50%',
            layout: 'fill'
          })
        })]
      })]
    })
  });
};
// EXTERNAL MODULE: ./config/index.ts
var config = __webpack_require__(9597);
;// CONCATENATED MODULE: ./pages/press.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Page = function Page(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Seo/* Seo */.p, {
      title: "Press | ".concat(config/* site.title */.l.title)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Screen, _objectSpread({}, props))]
  });
};

var __N_SSG = true;
/* harmony default export */ var press = (Page);

/***/ }),

/***/ 8254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ parseAndFormatDateForPresRelease; }
/* harmony export */ });
/* unused harmony export stripMarkdown */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7561);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(247);

/**
 * Super quick and dirty markdown stripper.
 * This doesn't follow the full markdown spec & there are likely bugs
 *
 * TODO: use a library to do this, don't have time right now
 */

function stripMarkdown(markdown) {
  var withoutNewlines = markdown.replace(/\n/g, ' ').replace(/\s+/g, ' ').trim();
  var withoutHeaders = withoutNewlines.replace(/^#+\s+/, '');
  var withoutLinks = withoutHeaders.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1');
  var withoutImages = withoutLinks.replace(/!\[([^\]]+)\]\(([^)]+)\)/g, '$1');
  var withoutCode = withoutImages.replace(/`+/g, '');
  var withoutItalics = withoutCode.replace(/\*+/g, '');
  var withoutBold = withoutItalics.replace(/\**/g, '');
  var withoutStrikethrough = withoutBold.replace(/~~/g, '');
  var withoutInlineCode = withoutStrikethrough.replace(/`/g, '');
  var withoutBlockQuotes = withoutInlineCode.replace(/^>\s+/gm, '');
  var withoutBullets = withoutBlockQuotes.replace(/^\s*\*\s+/gm, '');
  var withoutNumbers = withoutBullets.replace(/^\s*\d+\.\s+/gm, '');
  var withoutIndentation = withoutNumbers.replace(/^\s{2,}/gm, '');
  var withoutDashs = withoutIndentation.replace(/^\s*-\s+/gm, '');
  return withoutDashs;
}
/*
  date should be formatted like 1/10/2022 for January 10, 2022
 */

var parseAndFormatDateForPresRelease = function parseAndFormatDateForPresRelease(date) {
  var formatted;

  try {
    formatted = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(date, 'M-d-yyyy', new Date()), 'PPP');
  } catch (e) {
    // We shouldn't fall in here if we've provided date correctly
    // but it will at least prevent a hard failure on the frontend
    // like is currently happening on some devices in production
    console.error("Unable to parse date: ".concat(date));
    return '';
  }

  return formatted;
};

/***/ }),

/***/ 2351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ BASE_MDX_WRAPPER_STYLES; },
/* harmony export */   "i": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1895);

var BASE_MDX_WRAPPER_STYLES = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["", " li{", " p:not(:first-child){", "}}h1{", "}h2{", "}h3{", "}h4{", "}h5{", "}h6{", "}a{", "}ul,ol{", "}ol{", "}ul{", "}"], {
  "display": "flex",
  "flexDirection": "column",
  "gap": "1.25rem",
  "fontSize": "1.125rem",
  "lineHeight": "1.75rem"
}, {
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem"
}, {
  "paddingTop": "0.5rem"
}, {
  "fontSize": "1.875rem",
  "lineHeight": "2.25rem",
  "@media (min-width: 768px)": {
    "fontSize": "3rem",
    "lineHeight": "1"
  }
}, {
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "@media (min-width: 768px)": {
    "fontSize": "2.25rem",
    "lineHeight": "2.5rem"
  }
}, {
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "@media (min-width: 768px)": {
    "fontSize": "1.875rem",
    "lineHeight": "2.25rem"
  }
}, {
  "fontSize": "1.125rem",
  "lineHeight": "1.75rem",
  "@media (min-width: 768px)": {
    "fontSize": "1.5rem",
    "lineHeight": "2rem"
  }
}, {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "@media (min-width: 768px)": {
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem"
  }
}, {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "@media (min-width: 768px)": {
    "fontSize": "1.125rem",
    "lineHeight": "1.75rem"
  }
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(65 205 127 / var(--tw-text-opacity))",
  "textDecorationLine": "none"
}, {
  "listStylePosition": "outside",
  "paddingLeft": "1.5rem"
}, {
  "listStyleType": "decimal"
}, {
  "listStyleType": "disc"
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-1w2is1l-0"
})(["", " ", ""], BASE_MDX_WRAPPER_STYLES, function (_ref) {
  var styles = _ref.styles;
  return styles !== null && styles !== void 0 ? styles : '';
});

/***/ }),

/***/ 2348:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press",
      function () {
        return __webpack_require__(875);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [946,663,250,421,120,456,774,888,179], function() { return __webpack_exec__(2348); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);